<template>
    <div>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span style="line-height: 36px;">已分配设备列表</span>
            <el-button style="float: right;margin-left:10px;" type="success" @click="queryDeviceList(pageNo,pageSize)">查询</el-button>
            <el-date-picker
                style="float: right;"
                v-model="date_value"
                type="daterange"
                align="right"
                :placeholder="today"
                :picker-options="pickerOptions">
            </el-date-picker>
        </div>
        <div>
            <el-table
                v-loading="table_loading"
                element-loading-text="拼命加载中"
                :data="deviceData"
                stripe
                border
                fit
                height="520"
                style="width: 100%">
                <el-table-column
                    prop="deviceCode"
                    header-align="center"
                    min-width="110"
                    label="设备编号">
                </el-table-column>
                <el-table-column
                    prop="address"
                    header-align="center"
                    min-width="395"
                    label="设备地址">
                </el-table-column>
                <el-table-column
                    prop="host"
                    header-align="center"
                    min-width="100"
                    label="设备主">
                </el-table-column>
                <el-table-column
                    prop="count"
                    header-align="center"
                    min-width="95"
                    label="增粉次数">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    header-align="center"
                    min-width="105"
                    label="创建时间">
                </el-table-column>
            </el-table>
        </div>
        <div class="table_pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNo"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageTotal">
            </el-pagination>
        </div>
      </el-card>
    </div>
</template>

<script>
import $axios from '../../https/config'

export default {
  data () {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      today: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate() + ' - ' + new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
      date_value: '',
      pageSize: 10,
      pageNo: 1,
      table_loading: true,
      deviceData: [],
      pageTotal: 0
    }
  },
  created: function () {
    this.pageNo = 1
    this.queryDeviceList(this.pageNo, this.pageSize)
  },
  methods: {
    queryDeviceList (tPageNo, tPageSize) {
      var url
      var params
      var sDate = new Date(this.date_value[0])
      var eDate = new Date(this.date_value[1])
      this.table_loading = true
      var tStartDate = sDate.getFullYear() + '-' + (sDate.getMonth() + 1) + '-' + sDate.getDate()
      var tEndDate = eDate.getFullYear() + '-' + (eDate.getMonth() + 1) + '-' + eDate.getDate()
      if (this.date_value === '' || sDate.getFullYear() === 1970) {
        url = '/statictis/getStatictisByToday'
        params = {
          pageNo: tPageNo,
          pageSize: tPageSize
        }
      } else {
        url = '/statictis/getStatictisByDate'
        params = {
          pageNo: tPageNo,
          pageSize: tPageSize,
          startDate: tStartDate,
          endDate: tEndDate
        }
      }
      var _this = this
      $axios.get(url, params, 'headers', function (res) {
        if (res && res.resultStatus === true) {
          var resData = []
          if (res.resultData && res.resultData.list.length > 0) {
            _this.pageTotal = res.resultData.count
            for (var i = 0; i < res.resultData.list.length; i++) {
              var itemData = res.resultData.list[i]
              var item = {
                deviceCode: itemData.deviceCode,
                address: itemData.address,
                host: itemData.nickName,
                count: itemData.count,
                createTime: itemData.createTime
              }
              resData.push(item)
            }
            _this.deviceData = resData
            _this.pageTotal = res.resultData.count
          }
        } else {
        }
        _this.table_loading = false
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.queryDeviceList(this.pageNo, this.pageSize)
    },
    handleCurrentChange (val) {
      this.pageNo = val
      this.queryDeviceList(this.pageNo, this.pageSize)
    }
  }
}
</script>

<style>
    .table_pagination {
      text-align: right;
      margin-top: 10px; 
    }
</style>


// WEBPACK FOOTER //
// src/page/dataStatistics/dataDevice.vue